/** Last-name key for A–Z sorts. "Cruz, Leslie M" and "Leslie Cruz" both → cruz. */
export function lastNameKey(name: string | null | undefined): string {
  const raw = String(name || '').trim();
  if (!raw) return '';
  const base = raw.includes(',') ? raw.split(',')[0].trim() : raw;
  const parts = base.split(/\s+/).filter(Boolean);
  const last = parts[parts.length - 1] || base;
  return last.toLowerCase();
}

export function compareByLastName(a: string | null | undefined, b: string | null | undefined): number {
  const la = lastNameKey(a);
  const lb = lastNameKey(b);
  const byLast = la.localeCompare(lb, undefined, { numeric: true, sensitivity: 'base' });
  if (byLast !== 0) return byLast;
  return String(a || '').localeCompare(String(b || ''), undefined, { numeric: true, sensitivity: 'base' });
}
